import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/modules';
import { CookieConsentComponent } from './cookie-consent.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';

@NgModule({
  declarations: [CookieConsentComponent, CookiePolicyComponent],
  imports: [SharedModule],
  providers: [],
  exports: [CookieConsentComponent],
})
export class CookieConsentModule {}
